module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r6r8r7n-34241b5674cbe8fb236c9caada0ef919.svg";